/* Rider theme — vanilla JS, no dependencies */
(function () {
  'use strict';
  var T = window.RiderTheme || { routes: {}, strings: {} };
  T.routes = Object.assign({ cart: '/cart', cartAdd: '/cart/add', cartChange: '/cart/change', allProducts: '/collections/all' }, T.routes);

  /* ---------- Money ---------- */
  function formatMoney(cents) {
    var fmt = T.moneyFormat || '₹{{amount}}';
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var intPart = parts[0];
    // Indian digit grouping (1,00,000)
    var last3 = intPart.slice(-3), rest = intPart.slice(0, -3);
    if (rest) last3 = ',' + last3;
    var grouped = rest.replace(/\B(?=(\d{2})+(?!\d))/g, ',') + last3;
    var noDec = grouped;
    var withDec = grouped + '.' + parts[1];
    return fmt.replace(/\{\{\s*amount_no_decimals[^}]*\}\}/, noDec)
              .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec)
              .replace(/\{\{\s*amount\s*\}\}/, withDec)
              .replace(/<[^>]*>/g, '');
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('is-locked');
    var f = d.querySelector('input[type=search], button, a, input');
    if (f) setTimeout(function () { f.focus(); }, 50);
  }
  function closeDrawers() {
    document.querySelectorAll('.drawer.is-open').forEach(function (d) {
      d.classList.remove('is-open');
      d.setAttribute('aria-hidden', 'true');
    });
    document.body.classList.remove('is-locked');
    if (lastFocus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-open-drawer]');
    if (opener) { e.preventDefault(); openDrawer(opener.getAttribute('data-open-drawer')); return; }
    if (e.target.closest('[data-close-drawer]')) { e.preventDefault(); closeDrawers(); return; }
    var cartOpener = e.target.closest('[data-open-cart]');
    if (cartOpener && document.getElementById('CartDrawer') && !document.body.classList.contains('template-cart')) {
      e.preventDefault(); refreshCart().then(function () { openDrawer('CartDrawer'); });
    }
    var rec = e.target.closest('[data-toggle-recover]');
    if (rec) { e.preventDefault(); var r = document.getElementById('recover'); if (r) r.classList.toggle('is-open'); }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawers(); });

  /* ---------- Announcement rotator ---------- */
  document.querySelectorAll('[data-announce]').forEach(function (bar) {
    var items = bar.querySelectorAll('.announce__item');
    if (items.length < 2) return;
    var i = 0;
    setInterval(function () {
      items[i].classList.remove('is-active');
      i = (i + 1) % items.length;
      items[i].classList.add('is-active');
    }, 4200);
  });

  /* ---------- Hero slideshow ---------- */
  document.querySelectorAll('[data-slideshow]').forEach(function (el) {
    var slides = el.querySelectorAll('.hero__slide, .hb__slide');
    var dots = el.querySelectorAll('.hero__dot');
    if (slides.length < 2) return;
    var i = 0, timer = null;
    var speed = parseInt(el.getAttribute('data-autoplay'), 10) || 0;
    function go(n) {
      slides[i].classList.remove('is-active'); if (dots[i]) dots[i].classList.remove('is-active');
      i = (n + slides.length) % slides.length;
      slides[i].classList.add('is-active'); if (dots[i]) dots[i].classList.add('is-active');
    }
    function play() { if (speed > 0) { clearInterval(timer); timer = setInterval(function () { go(i + 1); }, speed * 1000); } }
    dots.forEach(function (d) { d.addEventListener('click', function () { go(parseInt(d.getAttribute('data-slide'), 10)); play(); }); });
    var pv = el.querySelector('[data-prev]'), nx = el.querySelector('[data-next]');
    if (pv) pv.addEventListener('click', function () { go(i - 1); play(); });
    if (nx) nx.addEventListener('click', function () { go(i + 1); play(); });
    var x0 = null;
    el.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    el.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 50) { go(i + (dx < 0 ? 1 : -1)); play(); }
      x0 = null;
    });
    el.addEventListener('mouseenter', function () { clearInterval(timer); });
    el.addEventListener('mouseleave', play);
    play();
  });

  /* ---------- Reveal on scroll ---------- */
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px' });
    document.querySelectorAll('.section .section-head, .tile, .card, .split__media, .split__content, .usp, .wcta, .lookbook__item').forEach(function (n) {
      n.classList.add('reveal'); io.observe(n);
    });
  }

  /* ---------- Cart (AJAX) ---------- */
  function updateCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) {
      c.textContent = count; c.hidden = count === 0;
    });
  }
  function renderCart(cart) {
    var wrap = document.querySelector('[data-cart-items]');
    var foot = document.querySelector('[data-cart-foot]');
    if (!wrap) return;
    updateCount(cart.item_count);
    var label = document.querySelector('[data-cart-count-label]');
    if (label) label.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.items.length) {
      wrap.innerHTML = '<div class="drawer-empty"><p class="h3">' + (T.strings.emptyCart || 'Your bag is empty') + '</p><a class="btn btn--primary" href="' + (T.routes.allProducts || '/collections/all') + '">Continue shopping</a></div>';
      if (foot) foot.hidden = true;
      return;
    }
    if (foot) foot.hidden = false;
    wrap.innerHTML = cart.items.map(function (item, idx) {
      var img = item.image ? item.image + (item.image.indexOf('?') > -1 ? '&' : '?') + 'width=200' : '';
      var variant = item.variant_title && item.variant_title !== 'Default Title' ? '<div class="dline__meta">' + item.variant_title + '</div>' : '';
      return '<div class="dline">' +
        '<a href="' + item.url + '">' + (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div><a class="dline__title" href="' + item.url + '">' + item.product_title + '</a>' + variant +
        '<div class="dline__qty"><button type="button" data-line="' + (idx + 1) + '" data-q="' + (item.quantity - 1) + '" aria-label="Decrease"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M5 12h14"/></svg></button>' +
        '<span>' + item.quantity + '</span>' +
        '<button type="button" data-line="' + (idx + 1) + '" data-q="' + (item.quantity + 1) + '" aria-label="Increase"><svg class="icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6"><path d="M12 5v14M5 12h14"/></svg></button></div></div>' +
        '<strong>' + formatMoney(item.final_line_price) + '</strong></div>';
    }).join('');
    var sub = document.querySelector('[data-cart-subtotal]');
    if (sub) sub.textContent = formatMoney(cart.total_price);
  }
  function refreshCart() {
    return fetch(T.routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { renderCart(c); return c; })
      .catch(function () {});
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-line]');
    if (!b) return;
    fetch(T.routes.cartChange + '.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: parseInt(b.getAttribute('data-line'), 10), quantity: Math.max(0, parseInt(b.getAttribute('data-q'), 10)) })
    }).then(function (r) { return r.json(); }).then(renderCart);
  });

  /* ---------- Product page ---------- */
  document.querySelectorAll('[data-product]').forEach(function (root) {
    var jsonEl = root.querySelector('[data-product-json]');
    if (!jsonEl) return;
    var product; try { product = JSON.parse(jsonEl.textContent); } catch (err) { return; }
    var form = root.querySelector('[data-product-form]');
    var idInput = root.querySelector('[data-variant-id]');
    var addBtn = root.querySelector('[data-add-button]');
    var priceEl = root.querySelector('[data-price]');
    var errEl = root.querySelector('[data-form-error]');

    // gallery
    function showMedia(id) {
      if (!id) return;
      root.querySelectorAll('.pdp__slide').forEach(function (s) { s.classList.toggle('is-active', String(s.getAttribute('data-media-id')) === String(id)); });
      root.querySelectorAll('.pdp__thumb').forEach(function (t) { t.classList.toggle('is-active', String(t.getAttribute('data-thumb')) === String(id)); });
    }
    root.querySelectorAll('.pdp__thumb').forEach(function (t) {
      t.addEventListener('click', function () { showMedia(t.getAttribute('data-thumb')); });
    });
    var main = root.querySelector('.pdp__main');
    if (main) {
      var sx = null;
      main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      main.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) < 40) return;
        var slides = Array.prototype.slice.call(root.querySelectorAll('.pdp__slide'));
        var cur = slides.findIndex(function (s) { return s.classList.contains('is-active'); });
        var next = slides[(cur + (dx < 0 ? 1 : -1) + slides.length) % slides.length];
        if (next) showMedia(next.getAttribute('data-media-id'));
      });
    }

    // variants
    function selectedOptions() {
      return Array.prototype.map.call(root.querySelectorAll('[data-option-index]'), function (fs) {
        var c = fs.querySelector('input:checked'); return c ? c.value : null;
      });
    }
    function findVariant(opts) {
      return product.variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    }
    function markAvailability(opts) {
      root.querySelectorAll('[data-option-index]').forEach(function (fs) {
        var idx = parseInt(fs.getAttribute('data-option-index'), 10);
        fs.querySelectorAll('.pill').forEach(function (pill) {
          var val = pill.querySelector('input').value;
          var test = opts.slice(); test[idx] = val;
          var v = findVariant(test);
          pill.classList.toggle('is-unavailable', !v || !v.available);
        });
      });
    }
    function update() {
      var opts = selectedOptions();
      root.querySelectorAll('[data-option-index]').forEach(function (fs, i) {
        var lbl = fs.querySelector('[data-option-value]'); if (lbl) lbl.textContent = opts[i] || '';
      });
      var v = findVariant(opts);
      markAvailability(opts);
      if (!v) {
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = T.strings.unavailable || 'Unavailable'; }
        return;
      }
      if (idInput) idInput.value = v.id;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.textContent = v.available ? (T.strings.addToCart || 'Add to bag') : (T.strings.soldOut || 'Sold out'); }
      if (priceEl) {
        var html = '<span class="price__current">' + formatMoney(v.price) + '</span>';
        if (v.compare_at_price && v.compare_at_price > v.price) {
          html += '<s class="price__compare">' + formatMoney(v.compare_at_price) + '</s><span class="price__off">' + Math.round((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '% off</span>';
          priceEl.classList.add('price--sale');
        } else { priceEl.classList.remove('price--sale'); }
        priceEl.innerHTML = html;
      }
      if (v.featured_media) showMedia(v.featured_media.id);
      if (window.history.replaceState) {
        var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      }
    }
    root.querySelectorAll('[data-option-index] input').forEach(function (inp) { inp.addEventListener('change', update); });
    if (root.querySelector('[data-option-index]')) markAvailability(selectedOptions());

    // quantity
    root.querySelectorAll('[data-qty]').forEach(function (b) {
      b.addEventListener('click', function () {
        var input = b.parentNode.querySelector('input');
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(b.getAttribute('data-qty'), 10));
      });
    });

    // add to cart
    if (form && document.getElementById('CartDrawer')) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (errEl) errEl.hidden = true;
        var original = addBtn ? addBtn.textContent : '';
        if (addBtn) { addBtn.disabled = true; addBtn.textContent = '…'; }
        fetch(T.routes.cartAdd + '.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) { if (errEl) { errEl.textContent = res.data.description || res.data.message || 'Could not add to bag'; errEl.hidden = false; } return; }
            return refreshCart().then(function () { openDrawer('CartDrawer'); });
          })
          .finally(function () { if (addBtn) { addBtn.disabled = false; addBtn.textContent = original; } });
      });
    }
  });

  /* ---------- Product recommendations ---------- */
  document.querySelectorAll('[data-recommendations]').forEach(function (el) {
    if (el.children.length) return;
    var url = el.getAttribute('data-url');
    if (!url) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var fresh = tmp.querySelector('[data-recommendations]');
      if (fresh && fresh.innerHTML.trim()) el.innerHTML = fresh.innerHTML;
    }).catch(function () {});
  });

  /* ---------- Collection sort ---------- */
  document.querySelectorAll('[data-sort]').forEach(function (s) {
    s.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', s.value); url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  });

  /* init cart count/drawer content */
  if (document.getElementById('CartDrawer')) refreshCart();
})();
